import { Routes } from '@angular/router';
import { AuthGuard } from '@/app/_infrastructure/adapters/guards/auth/auth.guard';
import { NotLoggedInUsersGuard } from '@/app/_infrastructure/adapters/guards/auth/not-loggedin.guard';
import { RoutingBase, RoutingPaths, RoutingAdapt, RoutingBlank, RoutingAuth, RoutingLoggedIn } from './common/routing';
import { RoutingClients } from './common/routing/clients/routing.clients';
import { BasicComponent } from './_presentation/shared/layout/basic/basic.component';
import { BlankComponent } from './_presentation/shared/layout/blank/blank.component';

export const ROUTES: Routes = [
  {
    path: RoutingPaths.Core,
    redirectTo: RoutingPaths.MainView,
    pathMatch: 'full'
  },
  {
    path: RoutingPaths.Core,
    component: BasicComponent,
    canActivate: [AuthGuard],
    children: [...RoutingLoggedIn, ...RoutingClients]
  },
  {
    path: RoutingPaths.Core,
    component: BlankComponent,
    canActivate: [NotLoggedInUsersGuard],
    children: [...RoutingBlank]
  },
  ...RoutingAuth,
  ...RoutingAdapt,
  ...RoutingBase,
  {
    path: RoutingPaths.InvalidRoute,
    pathMatch: 'full',
    loadComponent: () => import('./main-view/main-view.component').then((m) => m.MainViewComponent)
  }
];
